import React from "react";
import { XO_PAPER } from "./xoConvergenceBrand";
import { XOPublicRecoveryNavLinksReturn } from "./XOPublicRecoveryNav";

export type XONotFoundSurfaceProps = {
  /** When true, fills flex parent (sidebar layouts) instead of assuming full viewport */
  embedded?: boolean;
};

/**
 * Calm “surface not available” — not an error page, not a stack trace.
 */
export function XONotFoundSurface({ embedded }: XONotFoundSurfaceProps) {
  const inner = (
    <div
      style={{
        maxWidth: 520,
        marginInline: "auto",
        padding: embedded ? "32px 20px 48px" : "48px 24px 64px",
        boxSizing: "border-box",
        textAlign: "center",
      }}
    >
      <p
        style={{
          margin: 0,
          fontSize: "0.6875rem",
          fontWeight: 500,
          letterSpacing: "0.12em",
          textTransform: "uppercase",
          color: "rgba(200, 164, 77, 0.72)",
        }}
      >
        XO
      </p>
      <h1
        style={{
          margin: "16px 0 0",
          fontSize: "clamp(1.25rem, 3vw, 1.5rem)",
          fontWeight: 600,
          letterSpacing: "0.04em",
          lineHeight: 1.35,
          color: XO_PAPER,
        }}
      >
        This surface is not available yet.
      </h1>
      <p
        style={{
          margin: "16px 0 0",
          fontSize: "0.9375rem",
          fontWeight: 400,
          lineHeight: 1.5,
          color: "rgba(246, 240, 230, 0.72)",
        }}
      >
        Nothing is wrong with your connection — this path is not part of the public experience.
      </p>
      <XOPublicRecoveryNavLinksReturn />
    </div>
  );

  if (embedded) {
    return (
      <div
        style={{
          flex: 1,
          alignSelf: "stretch",
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          minHeight: 0,
          width: "100%",
        }}
      >
        {inner}
      </div>
    );
  }

  return inner;
}
